module.exports = __webpack_public_path__ + "static/media/dash-lg.c92a16b0.svg";